import { useMutation, useQueryClient } from '@tanstack/react-query';

import queryKeys from '@pray/shared/queryKeys';
import studioService from '@pray/shared/services/studioService';
import { mapCreditBalance } from '@pray/shared/services/studioService/credits';

type UseUpdateAllowOveragesProps = {
  artistId: string;
};

type UpdateAllowOveragesVariables = {
  allowOverage: boolean;
};

export function useUpdateAllowOverages({ artistId }: UseUpdateAllowOveragesProps) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ allowOverage }: UpdateAllowOveragesVariables) => {
      const response = await studioService.credits.updateAllowOverages({
        artistId,
        allowOverage,
      });

      return mapCreditBalance(response.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.artistCreditAccount(artistId),
      });
    },
  });

  return mutation;
}
